export default {
    key: 'harder-kulm',
    common: {
        productName: 'core.productNames.harder-kulm',
        splashMessage: 'offerFlow.splashMessage.harder-kulm',
        headingAside: 'offerFlow.headingAside.harder-kulm',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.harder-kulm',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
